import ReactTooltip from 'react-tooltip'

/**
 * Only overrides `left`, so that the Tooltip
 * fits to 100% of viewport
 */
export const mobileOverridePosition: ReactTooltip.Props['overridePosition'] = (position: {
  top: number
  left: number
}) => {
  const { top } = position || {}
  return {
    left: 0, // always make this 0 so it fits in mobile window
    top,
  }
}

/**
 * Simple conditional to determine whether to use a custom override
 * for `overridePosition` prop in <Tooltip />
 */
export const getOverridePositionProp = (
  isMobile: boolean
): ReactTooltip.Props['overridePosition'] | undefined => {
  if (!isMobile) return undefined
  return mobileOverridePosition
}
